import React, { FC, forwardRef } from 'react'
import ChocPagination from "choc-ui-paginator";
import { Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';

const Pagination: FC<Paginator.Pagination> = ({ currentPage, perPage, total, onClick }) => {
  const router = useRouter()

  const Prev = forwardRef((props, ref: any) =>
    <a ref={ref} {...props}>
      ‹
    </a>
  )

  Prev.displayName = "Prev";

  const Next = forwardRef((props, ref: any) =>
    <a ref={ref} {...props}>
      ›
    </a>
  )

  Next.displayName = "Next";

  const Backward = forwardRef((props, ref: any) =>
    <a ref={ref} {...props}>
      «
    </a>
  )

  Backward.displayName = "Backward";

  const Forward = forwardRef((props, ref: any) =>
    <a ref={ref} {...props}>
      »
    </a>
  )

  Forward.displayName = "Forward";

  const Page = forwardRef((props: { children: any }, ref: any) =>
    <a ref={ref} {...props}>
      {props.children}
    </a>
  )

  Page.displayName = "Page";

  const itemRender = (_, type) => {
    switch (type) {
      case "prev":
        return Prev
      case "next":
        return Next
      case "backward":
        return Backward
      case "forward":
        return Forward
      case "page":
        return Page
    }
  }

  const path = `${router.asPath.split('?')[0]}`

  return total ?
    <Flex
      w="full"
      alignItems="center"
      justifyContent="center"
      className="pagination"
    >
      <ChocPagination
        defaultCurrent={1}
        current={currentPage}
        total={total}
        pageSize={perPage}
        paginationProps={{ display: "flex" }}
        pageNeighbours={1}
        onChange={onClick}
        colorScheme="green"
        hideDisabledButtons={true}
        itemRender={itemRender}
        responsive={{ activePage: true, fastBackward: true, fastForward: true }}
        basePath={`${path}?pagina=`}
      />
    </Flex>
    : null
}

export default Pagination
